import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseListaComponent } from './base-lista.component';
import { GrupoModule } from '../grupo/grupo.module';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { SlideMenu, SlideMenuModule } from 'primeng/slidemenu';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';



@NgModule({
  declarations: [
    BaseListaComponent
  ],
  imports: [
    CommonModule,
    GrupoModule,
    ButtonModule,
    InputTextModule,
    FormsModule,
    RippleModule,
    TableModule,
    PaginatorModule,
    SlideMenuModule,
    ToastModule,
    ConfirmDialogModule,
    SlideMenuModule
  ],
  exports: [
    BaseListaComponent
  ]
})
export class BaseListaModule { }
